<template>
  <button class="slider__button">
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="8">
      <path
        v-if="orientation === 'left'"
        d="M.7431641 3.8574219l3.8930664
          3.8930664V4.5712891h9.5209961V3.1352539H4.6362305L4.6279297-.0356445z"
      />
      <path
        v-if="orientation === 'right'"
        d="M14.2568359 3.8574219l-3.8930664
          3.8930664V4.5712891H.8427734V3.1352539h9.5209961l.0083008-3.1708984z"
      />
    </svg>
  </button>
</template>

<script>
export default {
  name: 'SliderButton',

  props: {
    orientation: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";

.slider__button {
  display: inline-block;
  position: relative;
  width: 50px;
  height: 50px;

  background-color: transparent;
  border-radius: 25px;
  border: 1px solid $color-white;
  transition: border 0.2s ease-out;

  z-index: 10;

  cursor: pointer;

  @include mq(dm) {
    width: 66px;
    height: 66px;
    border-radius: 33px;
  }

  @include mq(dxl) {
    width: 90px;
    height: 90px;
    border-radius: 45px;
  }

  &:focus {
    outline: transparent;
  }

  &::before {
    content: '';

    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 100%;

    background-color: $color-white;
    transform: scale(0);
    transform-origin: center center;
    transition: transform 0.2s ease-out;

    z-index: -1;
  }

  path {
    fill: $color-white;
    transition: fill 0.2s ease-out;
  }

  @include mq($and: $is-not-touch-device) {
    &:hover {
      border: 1px solid transparent;
    }

    &:hover::before {
      transform: scale(1);
    }

    &:hover path {
      fill: $color-text;
    }
  }
}
</style>
